import { useRecordContext, useTranslate, useLocaleState } from 'react-admin';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';
import type { Channel } from '../../../../types/chat.types';

export const ChannelDetails = () => {
  const record = useRecordContext<Channel>();
  const translate = useTranslate();
  const [locale] = useLocaleState();

  if (!record) return null;

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          {translate('resources.channel.tabs.details')}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
          <Box>
            <Typography variant="caption" color="textSecondary">
              UUID
            </Typography>
            <Typography variant="body2">{record.uuid}</Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.channel.fields.type')}
            </Typography>
            <Typography variant="body2">
              {translate(`resources.channel.types.${record.type}`)}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.channel.fields.isEnabled')}
            </Typography>
            <Typography variant="body2">
              {record.isEnabled ? translate('ra.boolean.true') : translate('ra.boolean.false')}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.channel.fields.createdAt')}
            </Typography>
            <Typography variant="body2">
              {new Date(record.createdAt).toLocaleString(locale)}
            </Typography>
          </Box>
        </Box>

        {record.ticketConfig && (
          <Box mt={2}>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.channel.fields.config')}
            </Typography>
            <Box
              component="pre"
              sx={{
                bgcolor: 'action.hover',
                p: 1,
                borderRadius: 1,
                fontSize: 12,
                overflow: 'auto',
              }}
            >
              {JSON.stringify(record.ticketConfig, null, 2)}
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
